import React, { useEffect, useRef, useState } from "react";

// Animates from the previous value to `value` once, using rAF.
// No interval, no loop — fires only when `value` changes.
export default function CountUp({ value = 0, decimals = 2, prefix = "", suffix = "", duration = 700 }) {
  const [display, setDisplay] = useState(value);
  const fromRef = useRef(0);
  const rafRef = useRef(null);
  const startRef = useRef(0);

  useEffect(() => {
    const to = Number(value) || 0;
    const from = Number(fromRef.current) || 0;
    if (to === from) {
      setDisplay(to);
      return;
    }
    startRef.current = 0;

    const step = (ts) => {
      if (!startRef.current) startRef.current = ts;
      const p = Math.min((ts - startRef.current) / duration, 1);
      // easeOutCubic
      const eased = 1 - Math.pow(1 - p, 3);
      setDisplay(from + (to - from) * eased);
      if (p < 1) {
        rafRef.current = requestAnimationFrame(step);
      } else {
        fromRef.current = to;
      }
    };

    rafRef.current = requestAnimationFrame(step);
    return () => {
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
      fromRef.current = to;
    };
  }, [value, duration]);

  const formatted = Number(display).toLocaleString(undefined, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });

  return (
    <span>
      {prefix}
      {formatted}
      {suffix}
    </span>
  );
}
